<template>
  <div>
    <v-tooltip right open-delay="400">
      <template v-slot:activator="{ on }">
        <div
          :class="
            cx('wrapper', selectedItemStyle(isSelected), isBorderBottomNone)
          "
          v-on="on"
        >
          <div class="dataWrapper">
            <UpdateIndicator :point="point" />
            <Name :point="point" class="point-name" />
          </div>
          <div v-if="canEdit" class="switchWrapper">
            <AppInactiveSwitch
              v-if="isShowSwitch"
              :status="isSwitchActive"
              :disabled="isSwitchDisabled"
              :point="point"
              @change="onChange($event)"
            />
            <DeleteButton :point="point" />
          </div>
        </div>
      </template>
      <span>{{ point.name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import AppInactiveSwitch from '@/components/App/AppInactiveSwitch'
import UpdateIndicator from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/UpdateIndicator'
import DeleteButton from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/DeleteButton'
import Name from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/Name'
import selectedItemStyle from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/selectedItemStyle'
import { getters } from '@/vuex/modules/pointGroupOperation/constants'
import RouteHelper from '@/mixins/RouteHelper'
import { cx } from 'emotion'
import { actions } from '@/vuex/modules/pointGroupOperation/constants'
import immer from 'immer'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'Point',
  components: {
    AppInactiveSwitch,
    DeleteButton,
    UpdateIndicator,
    Name,
  },
  mixins: [RouteHelper],
  props: {
    point: Object,
    index: Number,
    last: Number,
    hasEditPermission: Boolean,
  },
  data() {
    return {
      boolean: false,
    }
  },
  computed: {
    isSwitchActive() {
      return this.point.status === 'active'
    },
    isSwitchDisabled() {
      return !(this.point.toDelete !== true && this.point)
    },
    isShowSwitch() {
      return !this.point.newItem.new
    },
    isBorderBottomNone() {
      if (this.index === this.last) {
        return 'borderBottomNone'
      }
      return null
    },
    cx() {
      return cx
    },
    selectedItemStyle() {
      return selectedItemStyle
    },
    selectedPoint() {
      return this.$store.getters[getters.selectedPoint]
    },
    isSelected() {
      const point = this.point
      const selectedPoint = this.selectedPoint
      // POIの時
      if ('id' in point) return false
      // 既存のポイントの場合（フェッチした時に存在する）
      if (!point.newItem.new) {
        return point.id === selectedPoint.id
      }
      // 新規ポイントの場合（フェッチした時に存在しない）
      return point.newItem.id === selectedPoint.newItem.id
    },
    canEdit() {
      return !this.underSystemOwnerPage && this.hasEditPermission
    },
  },
  methods: {
    onChange(isActive) {
      const point = cloneDeep(this.point)
      const data = immer(point, draft => {
        draft.status = isActive ? 'active' : 'inactive'
      })
      this.$store.dispatch(actions.EDIT_GROUP_POINT, {
        data,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding-left: 18%;
  padding-right: 10px;
  min-height: 37px;
}
.dataWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.switchWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.point-name {
  width: 150px;
}
// 以下条件分岐する
.borderBottomNone {
  border-bottom: 1px solid #d5d5d5;
}
</style>
